<script>
import TariffsTable from "../../../custom/tariffs-table.vue";

export default {
    name: "ZesaCalculatorContent",
    components: {TariffsTable}
}
</script>

<template>
    <div class="container">
        <div class="row">

            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h1 class="text-9 text-black mb-4">
                        How To Use The ZESA Calculator.
                    </h1>
                    <p class="text-3">
                        Get value from Magetsi’s ZESA Token Calculator, the ultimate tool for accurately calculating
                        your prepaid electricity units. Say goodbye to the hassle of guesswork and uncertainty. With
                        our ZESA calculator, you can confidently plan your prepaid electricity purchases while staying
                        informed about the financial breakdown of your payment. Our Zesa Units Calculator takes into
                        account  ZESA's stepped tariff system and the rural electrification levy to deliver accurate results.
                        Whether you want to know how much the units you want will cost or how many units the amount of money
                        you have can buy you. Our Magetsi Calculator will help you with just that, here’s how in 3 simple steps;
                    </p>
                    <ol class="text-3">
                        <li class="py-1">
                            First, confirm if this is your first purchase of ZESA tokens for this month. If you've already purchased
                            tokens earlier this month, kindly share the total amount you've spent on ZESA so far. This information
                            will help our zesa calculator app assist you more efficiently."
                        </li>
                        <li  class="py-1">
                            If you would like to calculate how many units your money will get you, choose the option “Number of
                            Units My Money Can Buy”. Alternatively, if you want to find the cost of a certain amount of units choose
                            the option “ How much it will cost to buy my units”
                        </li>
                        <li  class="py-1">
                            Enter the number of UNITS or the amount of ZWG you wish to spend and click crunch numbers and View Your Results.
                        </li>

                    </ol>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h3 class="text-5 text-black mb-4">
                        Bonus Feature On Our Zesa Calculator
                    </h3>
                    <h5 class="text-4 text-black mb-4">
                        Lost Your Zesa Token?
                    </h5>
                    <p class="text-3">
                        It’s frustrating to misplace important data and documents, worse your zesa token while your
                        family is at risk of spending the night in the dark.  Not to worry because Magetsi got you covered.
                        Our Units Calculator allows you to view your previous Zesa transaction (NB: Only when the zesa token
                        has been made via the Magetsi system). All you need is your transaction reference number.
                    </p>
                </div>
            </div>
            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h2 class="text-6 text-black mb-4">
                        How The Zesa Tariffs Calculator Works.
                    </h2>
                    <p class="text-3">
                        The number of units you will receive depends on multiple factors including the rural
                        electrification levy and consumption band. Our Zesa calculator takes into consideration these factors.
                    </p>
                </div>
                <div class="col-12 col-lg-8 pb-5">
                    <h3 class="text-5 text-black mb-4">
                        Zesa Units Calculator Current Rates.
                    </h3>
                    <p class="text-3">
                        Please note ZETDC updated it’s tariffs on a daily basis. For accurate zesa units calculations please use the Magetsi calculator.

                    </p>
                    <tariffs-table
                        table_type="zig_tariffs"
                    ></tariffs-table>
                    <tariffs-table
                        table_type="per_unit_tariffs"
                    ></tariffs-table>
                </div>
            </div>
            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h3 class="text-6 text-black mb-4">
                        How will the Zesa Token Calculator Benefit My Token Purchase?
                    </h3>
                    <ol class="text-3">
                        <li class="py-1">
                            Control Over Usage: With a prepaid meter, you have direct control over how much Zesa units you use. This helps in managing your Zesa consumption more effectively and avoiding unexpected high bills.
                        </li>
                        <li  class="py-1">
                            Budgeting: Prepaid meters allow you to budget your Zesa expenses more efficiently. You can top up your meter as needed, aligning your energy usage with your budgetary constraints.
                        </li>
                        <li  class="py-1">
                            No Surprises: Since you pay for Zesa upfront, there are no surprises in the form of hefty bills at the end of the month. This can be especially beneficial for budget-conscious individuals and households.
                        </li>
                        <li  class="py-1">
                            Convenience: Prepaid meters offer convenience as they can be easily recharged online, via Magetsi website or chatbot, or at various outlets. The Zesa calculator will give you an estimate of the amount of units you will receive after recharging.
                        </li>
                        <li  class="py-1">
                            No Disconnection Worries: With prepaid meters and our zesa units calculator, there's no risk of sudden disconnections due to unpaid bills. As long as you prepay your meter via magetsi you can continue to use electricity without interruptions.
                        </li>
                        <li  class="py-1">
                            Transparent Monitoring: You can easily calculate your units according to your usage to help track your finances.
                        </li>

                    </ol>
                </div>
            </div>
            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h3 class="text-5 text-black mb-4">
                        Where Do I Find My Token Number?
                    </h3>
                    <p class="text-3">
                        Now that you have calculated and purchased your prepaid electricity token, let’s delve into what your ZETDC receipt looks like and where you will find your zesa token number.  Your zesa token number is the 20-digit number you find on your receipt. To recharge punch the zesa token number into your zesa meter and press enter. You will immediately see the number of tokens you would have recharged.
                    </p>
                </div>
            </div>

            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h3 class="text-5 text-black mb-4">
                        How To Buy Zesa Online
                    </h3>
                    <p class="text-3">
                        Traditionally, soon after the introduction of prepaid meters in Zimbabwe in 2012, people relied on queuing at ZETDC to physically get zesa tokens. Through digitalization and innovation, Zesa tokens can now be accessed anywhere and anytime through multiple online platforms. You can buy your zesa token directly through your bank. But one of the most effective ways of buying zesa online with guaranteed customer support is through our Magetsi platform or our WhatsApp platform.
                    </p>
                </div>
            </div>
            <div class="px-2 py-3 text-justify ">
                <div class="my-auto mx-2">
                    <h3 class="text-5 text-black mb-4">
                        Frequently Asked Questions on Current Zesa Tariffs

                    </h3>
                    <div class="accordion accordion-alternate" id="popularTopics">
                        <div class="card">
                            <div class="card-header" id="heading1">
                                <h5 class="mb-0">
                                    <a href="#" class="collapsed" data-toggle="collapse"
                                       data-target="#collapse1" aria-expanded="false"
                                       aria-controls="collapse1">
                                        How do I top up my ZESA prepaid electricity on my meter?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse1" class="collapse" aria-labelledby="heading1"
                                 data-parent="#popularTopics">
                                <div class="card-body">
                                    <p class="text-3">
                                        <b>Answer:</b> To top up your ZESA prepaid electricity, follow these steps:
                                    </p>
                                    <ol class="text-3">
                                        <li class="py-1">
                                            Purchase a ZESA prepaid electricity token from Magetsi
                                        </li>
                                        <li  class="py-1">
                                            Enter the token into your prepaid electricity meter.
                                        </li>
                                        <li  class="py-1">
                                            The meter will validate the token and credit the purchased units to your meter.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading2">
                                <h5 class="mb-0">
                                    <a href="#"
                                       class="collapsed"
                                       data-toggle="collapse"
                                       data-target="#collapse2"
                                       aria-expanded="false"
                                       aria-controls="collapse2"
                                    >
                                        What are ZESA's current tariff structures?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse2" class="collapse" aria-labelledby="heading2"
                                 data-parent="#popularTopics">
                                <div class="card-body">
                                    <p class="text-3">
                                        <b>Answer:</b> ZESA tariffs are based on a stepped structure that allocates different rates for electricity consumption within a month. The more units you consume, the higher the tariff band you will fall under. Resulting in more money you pay per unit.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading3">
                                <h5 class="mb-0">
                                    <a href="#"
                                       class="collapsed"
                                       data-toggle="collapse"
                                       data-target="#collapse3"
                                       aria-expanded="false"
                                       aria-controls="collapse3"
                                    >
                                        I bought units for X amount but received a few units, Why is that?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse3" class="collapse" aria-labelledby="heading3"
                                 data-parent="#popularTopics">
                                <div class="card-body">
                                    <p class="text-3">
                                        <b>Answer:</b> There could be several reasons why you received fewer units than expected.
                                        It's essential to understand these factors to avoid any confusion in the future. Here are some possible reasons:
                                    </p>
                                    <ol class="text-3">
                                        <li class="py-1">
                                            Higher Tariff Band: If your electricity consumption has pushed you into a higher tariff band, you will be charged a higher rate per unit, resulting in fewer units for the same purchase amount. Tariffs bands are as follows,
                                            <br/>
                                            1 - 50 kWh<br/>
                                            51 - 100 kWh<br/>
                                            101 - 200 kWh<br/>
                                            201 - 300 kWh<br/>
                                            301 - 400 kWh<br/>
                                            400+ kWh
                                        </li>
                                        <li  class="py-1">
                                            Changes in Tariff Structures or Rates: ZESA may periodically revise its tariff structures or rates, impacting the number of units allocated for a given amount.
                                        </li>
                                        <li  class="py-1">
                                            Rural Electrification Levy: A portion of your payment (6%) goes towards the Rural Electrification Levy, aimed at expanding electricity access to rural areas. This levy reduces the amount that goes directly towards purchasing electricity units, resulting in fewer units for the same purchase amount.

                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading4">
                                <h5 class="mb-0">
                                    <a href="#"
                                       class="collapsed"
                                       data-toggle="collapse"
                                       data-target="#collapse4"
                                       aria-expanded="false"
                                       aria-controls="collapse4"
                                    >
                                        How do I save my electricity consumption?
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse4" class="collapse" aria-labelledby="heading4"
                                 data-parent="#popularTopics">
                                <div class="card-body">
                                    <ol class="text-3">
                                        <li class="py-1">
                                            Use Energy-Efficient Appliances: Invest in energy-efficient appliances with high Energy Star ratings. These appliances consume less electricity, saving you zesa units and  money in the long run.
                                        </li>
                                        <li  class="py-1">
                                            Unplug Unused Devices: Unplug electronics and appliances that are not in use, as they continue to consume standby power. Switch to LED Lighting: Replace traditional incandescent bulbs with energy-efficient LED bulbs. LEDs use significantly less energy and last much longer, reducing the number of zesa tokens you can buy in a month.
                                        </li>
                                        <li  class="py-1">
                                            Limit Hot Water Usage: Taking shorter showers and using cold water for laundry also help reduce hot water usage. Cold showers keep you energized throughout the day, it’s a win-win, saving your zesa and staying energized.
                                        </li>
                                        <li  class="py-1">
                                            Cook Efficiently: Use energy-efficient cooking methods such as using lids on pots and pans, matching pot sizes to burner sizes, and using microwave or toaster ovens for smaller meals this will limit the frequency at which you buy Zesa in a month.
                                        </li>
                                        <li  class="py-1">
                                            Regular Maintenance: Keep your appliances and HVAC systems well-maintained with regular servicing. Clean filters, coils, and vents to ensure optimal performance and energy efficiency.
                                        </li>
                                        <li  class="py-1">
                                            Educate and Involve Family Members: Encourage your family members to adopt energy-saving habits, such as turning off lights when leaving a room and using appliances responsibly. This will no doubt reduce the zesa units your family uses in a month.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="text-3">
                        Implementing these tips can lead to significant reductions in your electricity consumption and contribute to a more sustainable lifestyle.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
